import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "'HelveticaNowText','Roboto', 'Helvetica', 'Arial', sans-serif",
    fontSize: 16,
    h2: {
      fontSize: 16,
      fontWeight: 900,
      fontFamily:
        "'HelveticaNowDisplay','Roboto', 'Helvetica', 'Arial', sans-serif",
    },
  },
});

export default theme;
